// @greenlight-spec: 19-design-system.md
// @greenlight-spec: 20-agent-plugins.md

import * as React from 'react';

import { CodeBlock } from './CodeBlock';

export interface CommandStepsProps {
  caption: string;
  /** Run in order, one at a time — each gets its own copy control. */
  commands: readonly string[];
}

/**
 * Commands an operator runs one after another. A single block copying all of
 * them hands back a multi-line paste that an agent REPL takes as one command.
 */
export function CommandSteps({ caption, commands }: CommandStepsProps): React.ReactElement {
  const total = commands.length;
  return (
    <ol className="flex flex-col gap-2">
      {commands.map((command, index) => (
        <li key={command}>
          <CodeBlock
            caption={total > 1 ? `${caption} · ${index + 1} of ${total}` : caption}
            code={command}
            copyLabel={`Copy command ${index + 1} of ${total}: ${command}`}
          />
        </li>
      ))}
    </ol>
  );
}
